(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Container = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Container = function Container(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
      "div",
      { className: "container" },
      children
    );
  };

  exports.default = Container;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/layout/Container.js
// module id = 530
// module chunks = 0